import React, { useEffect, useState } from 'react';
import { Navigate, Link } from 'react-router-dom';
import { Container, Card, Row, Col, Form } from 'react-bootstrap';
import { Loader } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import { connect, useSelector } from 'react-redux';
import { Formik } from 'formik';
import * as yup from 'yup';
import Header from '../common/Header/Header';
import { axiosInstance } from '../../../api/axios';
import ToastMessage from '../common/ToastMessage/index';
import APIEndpoints from '../../api/APIEndpoints';
import CustomClientError from '../../errorhandling/CustomClientError';
import { HttpSuccessCodes } from '../../errorhandling/HttpErrorCodes';
import CookiesService from '../../shared/CookiesService';
import GenericButton from '../../../Components/GenericButton/GenericButton';
import EligibilityRelationships from './components/eligibility-relationship/EligibilityRelationships';
import EligibilityNotifications from './components/eligibility-relationship/EligibilityNotifications';
import EnrollmentRulesSkeleton from './components/eligibility-relationship/EnrollmentRulesSkeleton';

import 'react-web-tabs/dist/react-web-tabs.css';
const EnrollmentRules = () => {
  const [loader, setLoader] = useState(false);
  const [isAPIFailed, setIsAPIFailed] = useState(false);
  const [enrollRelationshipConfig, setenrollRelationshipConfig] = useState([]);
  const [relationNames, setrelationNames] = useState([]);
  const [isPostApi, setisPostApi] = useState(false);
  const [openHireData, setopenHireData] = useState({});
  const [newHireData, setnewHireData] = useState({});
  const [lifeEventData, setlifeEventData] = useState({});
  const [relationshipData, setrelationshipData] = useState([]);
  const { userData = {} } = useSelector((state) => state.user || {});
  const userType = userData?.UserType;
  const { blockOfBusiness, employer, location } = useSelector(
    (state) => state.breadCrumb,
  );
  const bearerToken = CookiesService.get('loginToken');
  const emp = employer.key;
  const loc = location.key || null;
  const blob = blockOfBusiness.key;
  const schema = yup.object({
    openEnrollEmail: yup
      .string()
      .email('Enter Valid email Address')
      .required('Please enter an email Address'),
    newHireEmail: yup
      .string()
      .email('Enter Valid email Address')
      .required('Please enter an email Address'),
    lifeEventEmail: yup
      .string()
      .email('Enter Valid email Address')
      .required('Please enter an email Address'),
  });
  useEffect(() => {
    window.scrollTo(0, 0);
    setLoader(true);
    const getEligibilityNotifications = async () => {
      const Employer = emp === 'all' ? '' : emp;
      const Location = loc === 'all' ? '' : loc;
      const BlockOfBusiness = blob === 'all' ? '' : blob;
      let paramString = '';
      paramString += `/bloboid/${BlockOfBusiness}`;

      paramString += `/clientoid/${Employer}`;

      if (Location) paramString += `/clientlocationoid/${Location}`;

      return await axiosInstance.get(
        APIEndpoints.getEligibilityRulesAndNotifications() + paramString,
      );
    };
    (async () => {
      try {
        const rules = await getEligibilityNotifications();
        const data = rules?.data?.Response?.EnrollmentRuleConfiguration;
        console.log('printed data', rules);
        const configuredRelations = data?.EnrollmentRelationshipConfig.map(
          (rel) => rel.RelationshipDescription,
        );
        setrelationNames(configuredRelations);

        setenrollRelationshipConfig(data?.EnrollmentRelationshipConfig);
        data?.EnrollmentRuleNotificationConfig.map((ele) => {
          if (ele.Category === 'Open Enrollment') {
            setopenHireData(ele);
          } else if (ele.Category === 'New-Hire Enrollment') {
            setnewHireData(ele);
          } else {
            setlifeEventData(ele);
          }
        });
        setIsAPIFailed(false);
        // setIsNotFound(false);
        setisPostApi(false);
      } catch (err) {
        if (err.toString().includes('404')) {
          // setIsNotFound(true);
          setisPostApi(true);
        }
        setIsAPIFailed(true);
        console.log(err);
      } finally {
        setLoader(false);
      }
    })();
  }, [blob, emp, loc]);
  //get relationship names
  useEffect(() => {
    setLoader(true);
    const getEligibilityRelationships = async () => {
      return await axiosInstance.get(
        APIEndpoints.getEligibilityRelationshipNames(),
      );
    };
    (async () => {
      try {
        const response = await getEligibilityRelationships();
        const data = response.data.Response.EnabledCode;
        console.log('code set data', data);
        setrelationshipData(data);
        setIsAPIFailed(false);
        // setIsNotFound(false);
        setisPostApi(false);
      } catch (err) {
        if (err.toString().includes('404')) {
          //  setIsNotFound(true);
          setisPostApi(true);
        }
        setIsAPIFailed(true);
        console.log(err);
      } finally {
        setLoader(false);
      }
    })();
  }, [blob, emp, loc]);

  const addRulesAndNotifications = async (values) => {
    const configData = {
      EnrollmentRuleConfigDTO: {
        BlobOid: blob,
        ClientOid: emp,
        ClientLocationOid: null,
        ClientId: '',
        ClientCode: '',
        EnrollmentRuleNotificationConfig: [
          {
            Category: 'Open Enrollment',
            EnrollmentCategoryOid: '',
            EmailOnRequest: values.openEmailReq,
            EmailOnRequestApproved: values.openEmailApproval,
            EmailOnRequestDenial: values.openEmailDenial,
            EmailAddress: values.openEnrollEmail,
          },
          {
            Category: 'New-Hire Enrollment',
            EnrollmentCategoryOid: '',
            EmailOnRequest: values.newHireEmailReq,
            EmailOnRequestApproved: values.newHireEmailApproval,
            EmailOnRequestDenial: values.newHireEmailDenial,
            EmailAddress: values.newHireEmail,
          },
          {
            Category: 'Life-Event Enrollment',
            EnrollmentCategoryOid: '',
            EmailOnRequest: values.lifeEventEmailReq,
            EmailOnRequestApproved: values.lifeEventEmailApproval,
            EmailOnRequestDenial: values.lifeEventEmailDenial,
            EmailAddress: values.lifeEventEmail,
          },
        ],
        EnrollmentRelationshipConfig: [
          {
            Code: '31',
            RelationshipDescription: 'Court Appointed Guardian',
          },
          {
            Code: '03',
            RelationshipDescription: 'Father or Mother',
          },
        ],
      },
    };
    return await axiosInstance.post(
      APIEndpoints.saveRulesAndNotifications(),
      configData,
    );
  };
  const handleSubmit = async (values) => {
    //Based on isPostApi = true then call .POST,  if it is false then .PUT
    try {
      const response = await addRulesAndNotifications(values);
      if (HttpSuccessCodes.HTTP_SUCCESS_CODE_200 === response.status) {
        toast.success(
          <ToastMessage type="success" subTitle={'updated successfully'} />,
        );
      }
    } catch (error) {
      console.log(error);

      toast.error(<ToastMessage type="error" subTitle={'updation failed'} />);
    }
  };

  function generateInitialValues(data) {
    const initialValues = {};
    relationshipData.forEach((field) => {
      initialValues[field.Description] = relationNames.includes(
        field.Description,
      )
        ? true
        : false;
    });

    const finalData = { ...data, ...initialValues };
    console.log('initialValues', initialValues);
    console.log('finalData', finalData);
    return finalData;
  }

  return (
    <Container fluid className="enrollmentrules">
      {loader ? (
        <EnrollmentRulesSkeleton />
      ) : isAPIFailed ? (
        <div className="claims-no-data text-center">
          <CustomClientError
            ErrorHeading="Something went wrong with request!"
            ErrorMessage="Please try again."
            CustomClasses="p-0"
          />
        </div>
      ) : (
        <div>
          <Header
            linkTo={'/admin/admin-dashboard'}
            header={'Manage Enrollment Rules'}
            className="enrollrules-header"
          />
          <Formik
            enableReinitialize
            validationSchema={schema}
            initialValues={
              generateInitialValues({
                openEmailReq: openHireData.EmailOnRequest,
                openEmailApproval: openHireData.EmailOnRequestApproved,
                openEmailDenial: openHireData.EmailOnRequestDenial,
                openEnrollEmail: openHireData.EmailAddress,
                newHireEmailReq: newHireData.EmailOnRequest,
                newHireEmailApproval: newHireData.EmailOnRequestApproved,
                newHireEmailDenial: newHireData.EmailOnRequestDenial,
                newHireEmail: newHireData.EmailAddress,
                lifeEventEmailReq: lifeEventData.EmailOnRequest,
                lifeEventEmailApproval: lifeEventData.EmailOnRequestApproved,
                lifeEventEmailDenial: lifeEventData.EmailOnRequestDenial,
                lifeEventEmail: lifeEventData.EmailAddress,
              })
              // openEmailReq: openHireData.EmailOnRequest,
              // openEmailApproval: openHireData.EmailOnRequestApproved,
              // openEmailDenial: openHireData.EmailOnRequestDenial,
              // openEnrollEmail: openHireData.EmailAddress,
              // newHireEmailReq: newHireData.EmailOnRequest,
              // newHireEmailApproval: newHireData.EmailOnRequestApproved,
              // newHireEmailDenial: newHireData.EmailOnRequestDenial,
              // newHireEmail: newHireData.EmailAddress,
              // lifeEventEmailReq: lifeEventData.EmailOnRequest,
              // lifeEventEmailApproval: lifeEventData.EmailOnRequestApproved,
              // lifeEventEmailDenial: lifeEventData.EmailOnRequestDenial,
              // lifeEventEmail: lifeEventData.EmailAddress,
              // Spouse: true,

              // Father or Mother: true,
              // grandfatherorgrandmother: true,
              // grandsonorgranddaughter: false,
              // uncleoraunt: false,
              // nepheworniece: true,
              // cousin: false,
              // adoptedchild: true,
              //relationshipData: [],
            }
            onSubmit={async (values) => {
              handleSubmit(values);
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              touched,
              errors,
              setFieldValue,
            }) => (
              <Tabs defaultTab="one">
                <TabList style={{ margin: '10px 20px 0px 20px' }}>
                  <Tab tabFor="one">Eligibility & Notifications</Tab>
                  <Tab tabFor="two">Rules</Tab>
                </TabList>
                <TabPanel tabId="one" style={{ marginLeft: '5px' }}>
                  <Form onSubmit={handleSubmit} className="border-right-after">
                    <EligibilityRelationships
                      values={values}
                      errors={errors}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched}
                      relationshipData={relationshipData}
                      enrollRelationshipConfig={enrollRelationshipConfig}
                      setFieldValue={setFieldValue}
                      relationNames={relationNames}
                    />
                    <EligibilityNotifications
                      values={values}
                      errors={errors}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <Row className="Payment-details border-bottom-0">
                      <Col className="float-right text-right">
                        <GenericButton
                          //disable={SavingRegSetup || !editReg}
                          postLabel="SAVE"
                          onClick={handleSubmit}
                          //buttonDisabled={!editReg}
                        >
                          SAVE
                        </GenericButton>
                      </Col>
                    </Row>
                  </Form>
                </TabPanel>
                <TabPanel tabId="two" style={{ marginLeft: '5px' }}>
                  {/*<EnrollmentRulesSkeleton /> */}
                  <Link to="/admin/enrollment-rules/create-new-rule">
                    {' '}
                    <GenericButton className="" block>
                      Gernerate New Rule
                    </GenericButton>
                  </Link>

                  {/*<Row className="Payment-details border-bottom-0">
                    <Col className="text-right">
                      <GenericButton
                        postLabel="List Rules"
                        //onClick={handleSubmit}
                      >
                        List
                      </GenericButton>
                    </Col>
                  </Row> */}
                </TabPanel>
              </Tabs>
            )}
          </Formik>
        </div>
      )}

      <div className="toastify">
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </Container>
  );
};
export default EnrollmentRules;
